import { setAuthorizationHeader } from "../services/axios";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export function auth(store) {
  store.on("@init", () => {
    const session = localStorage.getItem("session");
    const sessionObj = session && JSON.parse(session);

    if (sessionObj /*&& sessionObj.expire > new Date().getTime()*/) {
      return { auth: sessionObj };
    } else {
      localStorage.removeItem("session");
      return { auth: sessionObj };
    }
  });

  store.on(LOGIN, (_, auth) => {
    localStorage.setItem(
      "session",
      JSON.stringify({
        ...auth,
      }),
    );
    // set the token in the axios instance
    setAuthorizationHeader(auth.access_token);
    return { auth };
  });
  store.on(LOGOUT, ({ auth }) => {
    localStorage.removeItem("session");
    localStorage.removeItem("loggedInUser");
    return { auth: null };
  });
}
